// @utilities
import { APIGet } from "utilities/APIRequestHelper";
import apiURLBuilder from "core/apiURLBuilder";

const TAX_COUNTRY_NOT_SUPPORTED = "412";

export const validateTin = async (country, tin) => {
    try {
        await APIGet(null, apiURLBuilder.getURL("verifyTin", { country, tin }));
        return true;
    } catch (error) {
        if (error.text === TAX_COUNTRY_NOT_SUPPORTED) return true;
        return false;
    }
};
